import { Story } from "@/components/builder/stories/context";
import { Builder } from "@builder.io/react";

function createFakeStories(numberOfStories: number): Story[] {
  return Array.from({ length: numberOfStories }, (_, i) => i).map((i) => {
    return {
      id: `fake-story-${i}`,
      name: `Fake story ${i + 1}`,
      data: {
        slug: "loading",
        previewImage: "https://via.placeholder.com/300x300",
        genres: createFakeGenres(Math.floor(Math.random() * 3) + 1),
      },
      firstPublished: new Date().getTime(),
      lastUpdated: new Date().getTime(),
    };
  });
}

function createFakeGenres(numberOfGenres: number): string[] {
  return Array.from({ length: numberOfGenres }, (_, i) => i).map((i) => `Fake genre ${i + 1}`);
}

export function extractGenres(genres: string[]): string[] {
  return genres.length > 0 ? genres : Builder.isEditing ? createFakeGenres(5) : [];
}

export function extractStories(stories: Story[], initialOffset: number, numberOfStories?: number) {
  return stories.length > initialOffset
    ? stories.slice(initialOffset, numberOfStories && numberOfStories > 0 ? initialOffset + numberOfStories : undefined)
    : Builder.isEditing
      ? createFakeStories(numberOfStories || 10)
      : [];
}

export function buildStoryUrl(story: Story) {
  return `/stories/${story.data.slug}`;
}
